export default __webpack_public_path__ + "static/media/fb-contained-icon.8086fae9.svg";